module.exports = __webpack_public_path__ + "img/banner2.e7216b40.png";